import Vue from 'vue'
import $api from '@/shared/services/api'
export default {
    namespaced: true,
    state: {
        notificacoesNovas: 0,
        notificacoes: [],
        notificacoesCarregadas: false,
        carregandoNotificacoes: false,
        // Sistema
        notificacoesSistema: [],
        sistemaNovas: 0,
        carregandoSistema: false,
        sistemaCarregadas: false
    },
    getters: {
        listaNovasNotificacoes(state){
            return state.notificacoesNovas
        },
        listaNotificacoes(state){
            return state.notificacoes
        },
        notificacoesCarregadas(state){
            return state.notificacoesCarregadas
        },
        totalNovas(state){
            return state.notificacoesNovas + state.sistemaNovas
        }
    },
    mutations: {
        atualizaNovasNotificacoes(state, notificacoesNovas){
            state.notificacoesNovas = notificacoesNovas
            state.notificacoesCarregadas = true
        },
        atualizaNotificacoes(state, notificacoes){
            state.notificacoes = notificacoes
            state.notificacoesCarregadas = true
            state.carregandoNotificacoes = false
            state.notificacoesNovas = 0
        },
        atualizaSistema(state, { notificacoes, novas }){
            state.notificacoesSistema = notificacoes
            state.sistemaNovas = novas
            state.carregandoSistema = false
            state.sistemaCarregadas = true
        },
        atualizaSistemaNovas(state, novas){
            state.sistemaNovas = novas
        },
        marcaSistemaLidas(state){
            state.sistemaNovas = 0
            state.notificacoesSistema = state.notificacoesSistema.map(n => {
                n.Notificacao.lida = 1
                return n
            })
        }
    },
    actions: {
        carregaNovasNotificacoes({ state, commit }){
            state.notificacoesCarregadas = false
            $api.cGet(
                Vue.prototype.$urlBase
                + '/notificacoes/novas_notificacoes'
            ).then((res) => {
                if(res.status == 'success'){
                    commit('atualizaNovasNotificacoes', res.data)
                }
            }).catch((erro) => {
                console.log(erro)
            });
        },
        carregaNotificacoes({ state, commit }){
            state.carregandoNotificacoes = true
            $api.cGet(
                Vue.prototype.$urlBase
                + '/notificacoes/ultimas_notificacoes'
            ).then((res) => {
                if(res.status == 'success'){
                    commit('atualizaNotificacoes', res.data.notificacoes)
                }
            }).catch((erro) => {
                console.log(erro)
            });
        },
        carregaNotificacoesSistema({ state, commit }){
            state.carregandoSistema = true
            $api.cGet(
                Vue.prototype.$urlBase
                + '/notificacoes/notificacoes_sistema'
            ).then((res) => {
                if(res.status == 'success'){
                    commit('atualizaSistema', {
                        notificacoes: res.data.notificacoes,
                        novas: res.data.novas
                    })
                }
            }).catch((erro) => {
                console.log(erro)
            });
        },
        marcarSistemaLidas({ commit }){
            $api.cPost(
                Vue.prototype.$urlBase
                + '/notificacoes/marcar_sistema_lidas'
            ).then((res) => {
                if(res.status == 'success'){
                    commit('marcaSistemaLidas')
                }
            }).catch((erro) => {
                console.log(erro)
            });
        }
    },
}
